import { render, staticRenderFns } from "./AutocabPromotion.vue?vue&type=template&id=5159bb92&scoped=true"
import script from "./AutocabPromotion.vue?vue&type=script&lang=js"
export * from "./AutocabPromotion.vue?vue&type=script&lang=js"
import style0 from "./AutocabPromotion.vue?vue&type=style&index=0&id=5159bb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159bb92",
  null
  
)

export default component.exports